import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import JoyStick from "../Animations/JoyStick/JoyStick";
import ButtonAnimation from "../ButtonAnimation/ButtonAnimation";
import styles from "./BottomIcons.module.scss";

type BottomIconsProps = {
  eventCounter?: number;
};

export default function BottomIcons({ eventCounter }: BottomIconsProps) {
  const [buttonAnimation, setButtonAnimation] = useState(false);
  const [count, setCount] = useState(0);
  const [runAnimation, setRunAnimation] = useState(false);

  useEffect(() => {
    let countTimer: NodeJS.Timeout | null = null; // Declare countTimer outside to clear it on cleanup

    setButtonAnimation(false);
    const timer = setInterval(() => {
      setButtonAnimation((prevState) => !prevState);
      setRunAnimation((prevState) => !prevState);

      // Clear previous countTimer before starting a new one
      if (countTimer) {
        clearInterval(countTimer);
      }

      countTimer = setInterval(() => {
        setCount((prevCount) => (prevCount === 4 ? 0 : prevCount + 1));
      }, 300);

      // Automatically clear countTimer after its cycle completes
      setTimeout(() => {
        if (countTimer) {
          clearInterval(countTimer);
        }
      }, 1500); // 5 intervals * 300ms each = 1500ms
    }, 11000);

    // Cleanup function to clear both timers
    return () => {
      clearInterval(timer);
      if (countTimer) {
        clearInterval(countTimer);
      }
    };
  }, [eventCounter]);

  const opacity = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0 },
  };

  return (
    <div className={styles.bottom}>
      <AnimatePresence>
        {buttonAnimation && (
          <>
            <motion.div
              key="joystick"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={opacity}
            >
              <JoyStick
                runAnimation={runAnimation}
                count={count}
                type="bottom"
              />
            </motion.div>
            <motion.div
              key="buttonAnimation"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={opacity}
            >
              <ButtonAnimation color="white" />
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
